import React from 'react';
import type { ChannelSuggestion } from '@/hooks/useSuggestionsQuery';
import SuggestionCard from './SuggestionCard';

interface SuggestionRowProps {
  title: string;
  suggestions: ChannelSuggestion[];
}

const SuggestionRow: React.FC<SuggestionRowProps> = ({ title, suggestions }) => {
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <section className="mb-8">
      <h2 className="text-xl font-bold text-meradio-dark dark:text-text-dark-primary mb-4">
        {title}
      </h2>
      <div className="flex gap-4 overflow-x-auto pb-2">
        {suggestions.map((suggestion) => (
          <SuggestionCard key={suggestion.suggestedChannelId} suggestion={suggestion} />
        ))}
      </div>
    </section>
  );
};

export default SuggestionRow;
